import Component from 'vue-class-component';
import BaseComponent from '@/components/base/BaseComponent';

@Component({})
export default class BrowserCompatibilityComponent extends BaseComponent {
}
